import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/bhojanshala/donations";

export const Route = createFileRoute("/admin/_bhojanshala/bhojan-donations")({
  component: Page,
});
